import{renderIcon as e}from"../icon.renderer.js";const c="check",o=["check",e({outline:'<path d="M13.72,27.69,3.29,17.27a1,1,0,0,1,1.41-1.41l9,9L31.29,7.29a1,1,0,0,1,1.41,1.41Z"/>'})];export{o as checkIcon,c as checkIconName};
